import { t } from "@lingui/macro";

import {
  getFormattedDate,
  formatToTimeZone,
  getTimeZoneAbbr,
  getTimeZoneOffset,
  dateTimeFormatString
} from "base/utils";

export function lightenDarkenColor(col, amt) {
  var usePound = false;

  if (col[0] === "#") {
    col = col.slice(1);
    usePound = true;
  }

  var num = parseInt(col, 16);

  var r = (num >> 16) + amt;

  if (r > 255) r = 255;
  else if (r < 0) r = 0;

  var b = ((num >> 8) & 0x00ff) + amt;

  if (b > 255) b = 255;
  else if (b < 0) b = 0;

  var g = (num & 0x0000ff) + amt;

  if (g > 255) g = 255;
  else if (g < 0) g = 0;

  return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
}

export function focusAtEnd(ele) {
  const range = document.createRange();
  range.selectNodeContents(ele);
  range.collapse(false);
  const selection = window.getSelection();
  selection.removeAllRanges();
  selection.addRange(range);
}

export function focusAtInputEnd(ele) {
  ele.focus();
  const length = ele.value.length;
  ele.setSelectionRange(length, length);
}

export function getRemoteLookupDependentFields(field) {
  let rLookupData = field.getList("Field", "RemoteLookup")[0];
  let DependentObj = {};
  let HeaderPropertyList = rLookupData.getList("Header", "Property") || [];
  let BodyPropertyList = rLookupData.getList("Body", "Property") || [];
  let XpathExpressions = rLookupData.getList("XPATH", "Expression") || [];
  let rLookupExpressions =
    rLookupData.getList("RemoteLookup", "Expression") || [];
  let Expressions = [...XpathExpressions, ...rLookupExpressions];
  HeaderPropertyList.forEach((property) => {
    if (property.getValue("ValueType") === "Field") {
      let valueField = property.getValue("ValueField");
      DependentObj[valueField] = property.getValue("ValueType");
    }
  });

  BodyPropertyList.forEach((property) => {
    if (property.getValue("ValueType") === "Field") {
      let valueField = property.getValue("ValueField");
      DependentObj[valueField] = property.getValue("ValueType");
    }
  });

  Expressions.forEach((exp) => {
    let NodeParentList = exp.getList("Expression", "Node") || [];
    NodeParentList.forEach((node) => {
      let NodeList = node.getList("Node", "Node") || [];
      NodeList.forEach((nd) => {
        if (nd.getValue("Type") === "Field") {
          let valueType = nd.getValue("Field");
          DependentObj[valueType] = nd.getValue("Type");
        }
      });
    });
  });

  return Object.keys(DependentObj);
}

export function getTimeZoneDescription(dataString, locale, timeZone) {
  const formattedDateTime = formatToTimeZone(dataString, locale, timeZone);
  let timezoneAbbr = getTimeZoneAbbr(timeZone);
  let timezoneOffset = getTimeZoneOffset(timeZone, dataString);

  let dateTimeFormat = dateTimeFormatString(locale);
  let convertDateTimeFormat = getFormattedDate(
    formattedDateTime,
    "DD MMM YYYY, hh:mm A",
    dateTimeFormat
  );

  return `${t`Field submitted as`} ${convertDateTimeFormat} ${timezoneAbbr} (${timezoneOffset})`;
}

const hasClipboardWritePermission = async () => {
  try {
    if (navigator.clipboard) {
      const permissionResult = await navigator.permissions.query({
        name: "clipboard-write"
      });
      return (
        permissionResult.state === "granted" ||
        permissionResult.state === "prompt"
      );
    }
    return false;
  } catch {
    return Promise.reject("The Clipboard API is not available.");
  }
};

export const copyTextToClipboard = (content) => {
  hasClipboardWritePermission()
    .then(async (permission) => {
      if (permission) {
        await navigator.clipboard.writeText(content);
      } else {
        throw new Error("Clipboard permission denied by the user.");
      }
    })
    .catch((err) => {
      // Fallback to legacy approach if Clipboard API is not supported or permission is denied
      copyTextToClipboardLegacy(content);
      console.info("Clipboard write error:", err);
    });
};

export const copyTextToClipboardLegacy = (content) => {
  const textArea = document.createElement("textarea");
  textArea.value = content;
  document.body.appendChild(textArea);
  textArea.select();
  document.execCommand("copy");
  document.body.removeChild(textArea);
};
